/**
 * Вычисление количества каналов и HD для каждой темы каналов
 * и добавление результата в label
 * @returns {IFormattedChannelTheme[]}
 */

import { IChannelsDto, IFormattedChannelThemeDto } from '~/src/services/api/api-epg/v1/dto/IChannelsDto';

const defaultChannelsTheme = {
    id: 0,
    label: 'Все каналы',
    name: 'Все каналы',
    value: 0,
    weight: -1,
    channels: [],
    hasChannels: false,
};

const quantityHdChannels = (channels: IChannelsDto[]) => channels.reduce((quantityHd, channel) => {
    const currentHd = channel.quality === 'HD' ? 1 : 0;
    return quantityHd + currentHd;
}, 0);

export const getChannelThemesWithCounts = (allChannels: IChannelsDto[], channelThemes: IFormattedChannelThemeDto[]) => {
    if (allChannels?.length) {
        return [defaultChannelsTheme, ...channelThemes].map((theme) => {
            const { id } = theme;
            const themeChannels = allChannels.filter(channel => channel.categoryId === id);
            const hdCount = themeChannels.filter(channel => channel.quality === 'HD').length;
            const sdCount = themeChannels.length - hdCount;
            const countsSum = hdCount + sdCount;

            const tmpTheme = { ...theme };
            const allLabel = `(${countsSum})`;
            const hdLabel = hdCount ? `(${countsSum} / ${hdCount}HD)` : null;

            if (id === 0) {
                tmpTheme.label = `${tmpTheme.label} ${allChannels.length} (${quantityHdChannels(allChannels)}HD)`;
                tmpTheme.hasChannels = true;
            } else {
                tmpTheme.label = `${theme.label} ${hdLabel ? hdLabel : allLabel}`;
                tmpTheme.hasChannels = !!(countsSum);
            }

            return tmpTheme;
        }).filter(theme => theme.hasChannels);
    }

    return channelThemes;
};
